module.exports = __webpack_public_path__ + "img/lora.b54746ef.png";